import React from 'react'
import { CategoryProvider } from '../Providers/CategoryContext'

const CategoryWrapper = ({category, children}) => {
    return (
        <CategoryProvider category={category}>
            {children}
        </CategoryProvider>
    )
}

export default CategoryWrapper